import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Variables from '../../style/variables.scss';
import Constants from '../../utils/Constants';
import logo from '../../assets/imgs/logo_white.svg';
import menu from '../../assets/imgs/menu.jpg';
import scrollToPage from '../../utils/ScrollToLink';
import scrollDirection from '../../utils/ScrollDirection';
import ReservationModal from '../05_reservationModal/ReservationModal';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const direction = scrollDirection();

  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const [openReservationModal, setOpenReservationModal] =
    useState<boolean>(false);

  let header: HTMLElement | null = document.getElementById('nav_container');
  let headerBackground: HTMLElement | null =
    document.getElementById('nav_background');

  const handleLink = (target: string, page?: boolean) => {
    setOpenMenu(!openMenu);
    scrollToPage(target, location, navigate, page);

    setTimeout(() => {
      if (header !== null && headerBackground !== null && window.scrollY > 96) {
        headerBackground.style.top = '-10rem';
        header.style.top = '-10rem';
      }
    }, 600);
  };

  const handelHeaderAppearance = () => {
    if (header !== null && headerBackground !== null) {
      if (direction === 'up') {
        headerBackground.style.top = '0';
        header.style.top = '0';

        if (window.scrollY < 96) {
          headerBackground.style.borderBottom = 'unset';
        }
      } else if (direction === 'down') {
        headerBackground.style.top = '-10rem';
        header.style.top = '-10rem';

        if (window.scrollY >= 96) {
          headerBackground.style.borderBottom = `1px solid ${Variables.secondaryColor}`;
        }
      }
    }
  };

  window.onscroll = () => {
    handelHeaderAppearance();
  };

  useEffect(() => {
    if (openMenu) {
      document.body.classList.add('lock_scroll');
      document.getElementById('nav_menu')?.classList.add('open_sidemenu');
    } else {
      document.body.classList.remove('lock_scroll');
      document.getElementById('nav_menu')?.classList.remove('open_sidemenu');
    }
  }, [openMenu]);

  return (
    <div className='nav_wrapper'>
      <div id='nav_container'>
        <div className='nav_menu'>
          <div className='nav_menu_burger'>
            <input
              className='nav_menu_burger_cheeckbox'
              type='checkbox'
              onChange={() => setOpenMenu(!openMenu)}
              checked={openMenu}
            />
            <div>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
        <div
          className='nav_logo'
          onClick={() => scrollToPage('home', location, navigate)}
        >
          <img
            src={logo}
            alt={`${Constants.ACCOMMODATIONS_NAME} logo header`}
            id='nav_logo'
          />
        </div>
        <div className='nav_book'>
          <button
            type='button'
            onClick={() => setOpenReservationModal(true)}
            className='opacity_transition_low'
          >
            <div>RESERVE NOW</div>
          </button>
        </div>
      </div>
      <div id='nav_background'></div>
      <div id='nav_menu'>
        <div className='nav_menu_list'>
          <div className='nav_menu_list_links'>
            <div
              className='opacity_transition_high'
              onClick={() => handleLink(Constants.HOME)}
            >
              HOME
            </div>
            <div
              className='opacity_transition_high'
              onClick={() => handleLink(Constants.ACCOMMODATION)}
            >
              ACCOMMODATION
            </div>
            <div
              className='opacity_transition_high'
              onClick={() => handleLink(Constants.OFFERS)}
            >
              SPECIAL OFFERS
            </div>
            <div
              className='opacity_transition_high'
              onClick={() => handleLink(Constants.MICE, true)}
            >
              MICE
            </div>
            <div
              className='opacity_transition_high'
              onClick={() => handleLink(Constants.EXPERIENCE, true)}
            >
              EXPERIENCE
            </div>
            <div
              className='opacity_transition_high'
              onClick={() => handleLink(Constants.FEATURES)}
            >
              FEATURES
            </div>
            <div
              className='opacity_transition_high'
              onClick={() => handleLink(Constants.GALLERY, true)}
            >
              GALLERY
            </div>
            <div
              className='opacity_transition_high'
              onClick={() => handleLink(Constants.AUTHENTICITY)}
            >
              BARS
            </div>
            <div
              className='opacity_transition_high'
              onClick={() => handleLink(Constants.RESTAURANTS, true)}
            >
              RESTAURANTS
            </div>
            <div
              className='opacity_transition_high'
              onClick={() => handleLink(Constants.WELLNESS, true)}
            >
              WELLNESS
            </div>
            <div
              className='opacity_transition_high'
              onClick={() => handleLink(Constants.SERVICES, true)}
            >
              SERVICES
            </div>
            <div
              className='opacity_transition_high'
              onClick={() => handleLink(Constants.DESTINATION)}
            >
              DESTINATION
            </div>
            <div
              className='opacity_transition_high'
              onClick={() => handleLink(Constants.B2B, true)}
            >
              B2B
            </div>
            <div
              className='opacity_transition_high'
              onClick={() => handleLink(Constants.SUSTAINABILITY, true)}
            >
              SUSTAINABILITY
            </div>
          </div>
          <div className='nav_menu_list_image'>
            <img src={menu} alt={`${Constants.ACCOMMODATIONS_NAME} menu`} />
          </div>
        </div>
      </div>
      <ReservationModal
        isOpen={openReservationModal}
        onClose={setOpenReservationModal}
      />
    </div>
  );
};

export default Header;
